<template>
  <v-container style="height: 80vh;">
    <v-row class="text-center pt-4" justify="center">
      <v-col md="6">
        <v-card outlined elevation="0">
          <v-card-text>
            <div class="py-12" v-if="isLoading">
              <h1 class="display-1 mb-4 text-center font-weight-medium">
                Loading
              </h1>
              <v-progress-linear
                rounded
                :buffer-value="buffer"
                :value="value"
                stream
                color="primary"
              ></v-progress-linear>

              <p class="mt-4">{{ message }}</p>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  data() {
    return {
      message: 'Checking your details...',
      buffer: 0,
      value: 0,
      isLoading: true,
    }
  },
  computed: {
    ...mapGetters([
      'userDetails',
      'weekData',
      'weekHasExpired',
      'weekExpiresToday',
    ]),
  },
  mounted() {
    this.loadPWA()
    this.loadFontAwesomeCSS()
  },
  methods: {
    loadFontAwesomeCSS() {
      let file = document.createElement('link')
      file.rel = 'stylesheet'
      file.href = 'https://use.fontawesome.com/releases/v5.8.2/css/all.css'
      document.head.appendChild(file)
    },
    async sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    async loadPWA() {
      // For PWA auto-login: send request to api and redirect to app if ok
      const jwt = localStorage.getItem('lb-jwt')
      if (jwt) {
        try {
          const userData = await this.$store.dispatch('checkUser')
          this.message = 'Retrieving your profile'
          this.value = '10'
          // await this.sleep(600)
          await this.$store.dispatch('getProfile', {
            userId: this.userDetails.id,
          })
          this.value = '30'

          await this.$store.dispatch('updateProfile', {
            id: this.userDetails.profile.id,
            body: {lastActivity: new Date()},
          })

          this.message = 'Retrieving your Goals and Habits'
          // await this.sleep(1000)
          await this.$store.dispatch('getGoals')
          await this.$store.dispatch('getHabits')
          this.value = '60'

          this.message = 'Retrieving your Week details'
          // await this.sleep(700)

          await this.$store.dispatch('getWeekStack')
          this.value = '85'

          // await this.sleep(200)
          this.value = '95'

          if (!this.userDetails.profile) {
            // await this.sleep(800)

            this.message = 'Redirecting you to onboarding'
            return this.$router.push(`/@${this.userDetails.name}/onboard`)
          } else if (this.weekData.id && this.weekData.version) {
            if (this.weekHasExpired || this.weekExpiresToday) {
              this.message = 'Redirecting you to your Week Review'
              return this.$router.push(`/@${this.userDetails.name}/week-review`)
            }
            // await this.sleep(800)
            this.message = 'Redirecting you to your Week page'
            return this.$router.push(`/@${this.userDetails.name}/week-view`)
          } else if (this.weekData.id) {
            // await this.sleep(800)
            this.message = 'Redirecting you to your Week page'
            return this.$router.push(`/@${this.userDetails.name}/week`)
          }
          // redirect to goals/habits page
          // await this.sleep(800)
          this.message = 'Redirecting you to your Goals & Habits page'
          return this.$router.push({
            name: 'goalshabits',
            params: {name: this.userDetails.name},
          })
        } catch (error) {
          return this.$router.push(`/login`)
        }
      } else {
        //there is no JWT
        this.isLoading = false
        return this.$router.push(`/login`)
      }
    },
  },
}
</script>

<style></style>
